export default {
	account: 'Account name',
	'Ali iconcont Icon': 'Ali Iconfont Icon',
	array: 'Array',
	ArrayKey: 'Key',
	ArrayValue: 'Value',
	Breakdown: 'Detailed catalogue',
	checkbox: 'checkbox',
	choice: ' Choice',
	'city select': 'City select',
	'Clean up all cache': 'Clean up all cache',
	'Clean up browser cache': 'Clean up browser cache',
	'Clean up system cache': 'Clean up the system cache',
	close: 'Close',
	color: 'color',
	'color picker': 'color picker',
	comma: ',',
	date: 'Date',
	Dict: 'Dict',
	email: 'Email address',
	Extend: 'Extend',
	'Extended properties of Input, one line without quotation marks, such as: size=large':
		'Extended properties of Input, one line without quotation marks, such as: size=large',
	file: 'File',
	float: 'Float',
	'good afternoon': 'Good afternoon.',
	'Good evening': 'Good evening',
	'good morning!': 'Good morning!',
	'Good morning!': 'Good morning!',
	'Good noon!': 'Good noon!',
	'Hello!': 'Hello!',
	Icon: 'Icon',
	'icon select': 'Icon select',
	'Id number': 'Id Number',
	image: 'Image',
	integer: 'Integer',
	items: 'items',
	'Last upload time': 'Last upload time',
	'Late at night, pay attention to your body!': 'It is late at night. Please tack care of your body!',
	Loading: 'Loading...',
	'Local icon title': 'Local icon:/src/assets/icons Inside.svg',
	mobile: 'Mobile Number',
	'multi image': 'Multi image',
	Name: 'Name',
	'No data': 'No data',
	number: 'Number',
	'One attribute per line without quotation marks(formitem)':
		'Extensions to FormItem, One attribute per line, no quotation marks required, such as: class=config-item',
	'One line at a time, without quotation marks, for example: key1=value1': 'One per line, no quotation marks required, such as: key1=value1',
	open: 'Open',
	'Original name': 'Original name',
	password: 'password',
	'Please install editor': 'Please install editor',
	'Please select an icon': 'Please select an icon',
	preview: 'Preview',
	radio: 'Radio',
	Reload: 'Reload',
	'remote select': 'Remote Select',
	'rich Text': 'Rich Text',
	Rule: 'Rule',
	select: 'Select',
	'Select File': 'Select File',
	size: 'Size',
	string: 'String',
	switch: 'Switch',
	textarea: 'Textarea',
	'The data of the uploaded file is incomplete!': 'The data of the uploaded file is incomplete!',
	'The moving position is beyond the movable range!': 'The movement position is beyond the removable range!',
	'The size of the uploaded file exceeds the allowed range!': 'The size of the uploaded file exceeds the allowed range!',
	'The type of uploaded file is not allowed!': 'The type of uploaded file is not allowed!',
	time: 'Time',
	'time date': 'Time Date',
	Tip: 'Tip',
	Title: 'Title',
	type: 'Type',
	'Upload (Reference) times': 'Upload (Reference) times',
	Var: 'Var ',
	'variable name': 'Variable Name',
	'welcome back': 'Welcome back!',
	year: 'Year',
	'You can also select': 'You can also select',
	'导航失败，菜单类型无法识别！': 'Navigation failed, menu type not recognized!',
	'导航失败，导航守卫拦截！': 'Navigation failed, Navigation Guard interception!',
	'导航失败，路由无效！': '导航失败，路由无效！',
	'导航失败，已在导航目标位置！': 'Navigation failed, it is already at the navigation the position!',
	'没有找到可以跳转的子级菜单！': '没有找到可以跳转的子级菜单！',
	清除成功: 'Cleared successfully',
}
